<template>
  <div class="amazon-info">
    <validation-component
      ref="amazonForm"
      :validation-condition="amazonCondition"
    >
    </validation-component>
  </div>
</template>

<script>
import { REQUIRED, EMAIL } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import GlobalData from '@/utils/global/index';
import { initSelectedData } from '@/utils/tools/constant';
import { checkCharLength } from '@/utils/tools/utils';
import { AMAZON_SITE_URL_MAP } from '@/views/collection/api/options.js';

export default {
  components: {
    ValidationComponent,
  },
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      amazonCondition: [{
        key: 'appName',
        name: 'message.application.merchantName',
        type: 'input',
        defValue: '',
        isShowStar: true,
        placeholder: this.$t('message.validator.input', { select: '' }),
        rule: [REQUIRED],
        maxLength: 64,
        validator: this.validateAppName,
      }, {
        key: 'site',
        name: 'message.application.site',
        type: 'select',
        defValue: '',
        isShowStar: true,
        placeholder: this.$t('message.validator.select', { select: '' }),
        rule: [REQUIRED],
        changeValue: () => {
          this.formatStoreUrl();
        },
      }, {
        key: 'accountName',
        name: 'message.collection.bankName',
        type: 'input',
        defValue: '',
        isShowStar: true,
        placeholder: this.$t('message.validator.input', { input: '' }),
        rule: [REQUIRED],
      }, {
        key: 'sellerId',
        name: 'message.application.sellId',
        type: 'input',
        defValue: '',
        isShowStar: true,
        placeholder: this.$t('message.validator.input', { input: '' }),
        rule: [REQUIRED],
        changeValue: () => {
          this.formatStoreUrl();
        },
      }, {
        key: 'applyChannelEmail',
        name: 'message.application.applyChannelEmail',
        type: 'input',
        defValue: '',
        isShowStar: true,
        placeholder: this.$t('message.validator.input', { select: '' }),
        rule: [REQUIRED, EMAIL],
        changeValue: (value) => {
          const v = value || '';
          this.$refs.amazonForm.setItemValue('applyChannelEmail', v.toLocaleLowerCase());
        },
      }, {
        key: 'storeUrl',
        name: 'message.application.storeUrl',
        type: 'input',
        defValue: '',
        isShowStar: true,
        rule: [REQUIRED],
        isDisabled: true,
      }],
    };
  },
  mounted() {
    this.initMethod();
  },
  methods: {
    async initMethod() {
      const dict = await GlobalData.getDictList(['AMAZON_EU_MARKETPLACE']);
      this.$refs.amazonForm.setValidationSelectOptions('site', initSelectedData(dict.AMAZON_EU_MARKETPLACE, 'description', 'value', false));
      this.$refs.amazonForm.assignmentFormValue(this.info);
      if (this.info.site) {
        this.$refs.amazonForm.setItemDisabled('site', true);
      }
    },
    validateAppName(rule, value, callback) {
      if (value && !checkCharLength(value, 64)) {
        callback(new Error(this.$t('message.application.appNameErrorTips')));
      }
      callback();
    },
    formatStoreUrl() {
      let storeUrl = '';
      const site = this.$refs.amazonForm.getItemValue('site');
      if (site) {
        storeUrl = AMAZON_SITE_URL_MAP[site] || '';
      }
      const sellerId = this.$refs.amazonForm.getItemValue('sellerId');
      if (sellerId) {
        storeUrl = `${storeUrl}${sellerId}`;
      }

      this.$refs.amazonForm.setItemValue('storeUrl', storeUrl);
    },
    async getParams() {
      return new Promise((resolve, reject) => {
        this.$refs.amazonForm.toFormValid((params) => {
          resolve(params);
        }, (err) => {
          reject(err);
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.amazon-info {
  margin-bottom: -20px;

  ::v-deep .rhch-upload-container {
    width: 450px;
    min-width: auto;
    .el-upload-dragger, .rhch-file-list {
      width: 450px;
      min-width: auto;
    }

    .rhch-file-list .rhch-file-item .rhcn-filename {
      max-width: 240px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
}
</style>
